<template>
  <svg :width="width" :height="height" viewBox="0 0 10 6" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.50495 5.78413L0.20524 1.25827C-0.0684147 0.970375 -0.0684147 0.503596 0.20524 0.215836C0.478651 -0.071946 0.922098 -0.071946 1.19549 0.215837L5.00007 4.22052L8.80452 0.215953C9.07805 -0.0718293 9.52145 -0.0718292 9.79486 0.215953C10.0684 0.503736 10.0684 0.970491 9.79486 1.25839L5.49508 5.78424C5.35831 5.92814 5.17925 6 5.00009 6C4.82085 6 4.64165 5.928 4.50495 5.78413Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: String, default: '' },
    height: { type: String, default: '' },
    color: { type: String, default: '' },
  },
}
</script>
